import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AdapterProvider } from './adapters/AdapterProvider'
import { BlockConfiguratorRoute } from './block-configurator/BlockConfiguratorRoute'
import { BlocksGallery } from './galleries/BlocksGallery'
import { RulesGallery } from './galleries/RulesGallery'
import { TemplatesGallery } from './galleries/TemplatesGallery'
import { PrintersRoute } from './printing/PrintersRoute'
import { RuleConfiguratorRoute } from './rule-configurator/RuleConfiguratorRoute'
import { AppShell } from './shell/AppShell'
import { CmdK } from './shell/CmdK'
import { CmdKProvider } from './shell/CmdKContext'
import { ErrorBoundary } from './shell/ErrorBoundary'
import { NavGuardProvider } from './state/NavGuard'
import { TemplateDesignerRoute } from './template-designer/TemplateDesignerRoute'
import { ConfirmProvider } from './ui/ConfirmDialog'
import { ToastProvider } from './ui/Toaster'

export default function App() {
  return (
    <AdapterProvider>
      <ConfirmProvider>
      <ToastProvider>
      <CmdKProvider>
        <BrowserRouter>
          <NavGuardProvider>
          <ErrorBoundary>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<Navigate to="/templates" replace />} />
              <Route path="/templates" element={<TemplatesGallery />} />
              <Route path="/templates/new" element={<TemplateDesignerRoute />} />
              <Route path="/templates/:templateId" element={<TemplateDesignerRoute />} />
              <Route path="/blocks" element={<BlocksGallery />} />
              <Route path="/blocks/new" element={<BlockConfiguratorRoute />} />
              <Route path="/blocks/:blockId" element={<BlockConfiguratorRoute />} />
              <Route path="/rules" element={<RulesGallery />} />
              <Route path="/rules/new" element={<RuleConfiguratorRoute />} />
              <Route path="/rules/:ruleId" element={<RuleConfiguratorRoute />} />
              <Route path="/printers" element={<PrintersRoute />} />
              <Route path="*" element={<Navigate to="/templates" replace />} />
            </Route>
          </Routes>
          <CmdK />
          </ErrorBoundary>
          </NavGuardProvider>
        </BrowserRouter>
      </CmdKProvider>
      </ToastProvider>
      </ConfirmProvider>
    </AdapterProvider>
  )
}
